import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    region = "region",
    portalId = "portalId",
    formId = "formId",
    target = "target",
}

interface Props extends WidgetProps {
    fields: {
        [fields.region]: string;
        [fields.portalId]: number;
        [fields.formId]: string;
        [fields.target]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
    currentLocation: getLocation(state),
    page: getCurrentPage(state),
});
type OwnProps = Props & HasProduct & ReturnType<typeof mapStateToProps> & HasShellContext;
export interface INTHubSpotWidgetStyles {
    hubSpotWidgetMain?: InjectableCss;
    mainDiv?: InjectableCss;
    sectionOne?: InjectableCss;
}

export const iNTHubSpotWidgetStyles: INTHubSpotWidgetStyles = {
    mainDiv: {
        css: css`
            background: #275aa8;
            padding: 25px;
            border-radius: 3px;
        `,
    },
    sectionOne: {
        css: css`
            > h2 {
                font-size: 30px;
                color: #fff;
                margin: 0px 0px 10px 0px;
            }
            > p {
                font-size: 15px;
                color: #fff;
                margin: 0px 0px 20px 0px;
            }
        `,
    },
    hubSpotWidgetMain: {
        css: css`
            > form > fieldset > div > label {
                color: #ffff;
                margin-top: 5px;
                > .hs-form-required {
                    color: red;
                    padding-left: 1px;
                }
            }
            > form > fieldset > div {
                margin-bottom: 15px;
            }
            > form > fieldset > div > ul > li > .hs-error-msg {
                color: #f1eb36;
                font-size: 13px;
            }
            > form > div > ul > li > .hs-main-font-element {
                color: #f1eb36;
                margin-top: 10px;
            }
            > form > div > ul {
                margin-top: 15px;
                text-align: center;
            }
            > form > fieldset > div > div > ul > li > .hs-error-msg {
                color: #f1eb36;
                font-size: 13px;
            }
            > form > .hs_submit {
                margin: 24px 0px 0px 0px;
                text-align-last: center;
            }
            > form > .hs_recaptcha {
                text-align: -webkit-center;
                margin-top: 4px;
            }
            > form > div > div:nth-child(2) {
                > .hs-button {
                    padding: 10px 8px;
                    width: 80%;
                    color: #fff;
                    background: #363636;
                    border: none;
                    text-transform: uppercase;
                    font-weight: 600;
                    letter-spacing: 0.3px;
                    border-radius: 3px;
                    font-family: inherit;
                }
                > .hs-button:hover {
                    color: #363636;
                    background: #fff;
                    border: none;
                }
            }
            > form fieldset {
                > div > div > input {
                    padding: 3px 4px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    height: 30px;
                    border: none;
                    border-radius: 2px;
                    font-family: inherit;
                }
                > div > div > input:focus {
                    background-color: white;
                }
                > div > div > div > input:focus {
                    background-color: white;
                }
                > div > div > div > input {
                    padding: 3px 4px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    height: 33px;
                    border: none;
                }
                > div > div > div > input[type="file"] {
                    color: white;
                    background: none;
                }
                > div > div > textarea {
                    min-height: 100px;
                    margin-top: 3px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    border-radius: 3px;
                    font-family: inherit;
                }
                > div > div > textarea:focus {
                    background-color: white;
                }
                > div > div > div > ul > li {
                    padding: 3px 0px;
                    color: #ffff;
                }
                > div > div > label > span {
                    color: #ffff;
                }
                > div > div > label .hs-form-required {
                    color: red;
                    padding-left: 1px;
                }
                > div > div > div > select {
                    padding: 4px 4px;
                    width: 100% !important;
                    margin-top: 3px;
                    background-color: #dfd9d9fc;
                    height: 33px;
                    border: none;
                    border-radius: 2px;
                    font-family: inherit;
                }
                > div > div > div > select:focus {
                    background-color: white;
                }
            }
            > form {
                > .form-columns-2 {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                > .form-columns-2 > div {
                    width: 48% !important;
                    float: initial !important;
                    > div > input {
                        width: 100% !important;
                    }
                }
            }
        `,
    },
};

const styles = iNTHubSpotWidgetStyles;

const INTHubSpotWidget: React.FunctionComponent<OwnProps> = props => {
    const { cart, currentLocation, page, product } = props;
    let vendorData = "";
    let suppliers = "";
    let model = "";

    const loadHubSpotForm = () => {
        if(typeof window !== undefined) {
            const script = document.createElement("script");
            script.src = "https://js.hsforms.net/forms/embed/v2.js";
            document.body.appendChild(script);
            script.addEventListener("load", () => {
                if ((window as any).hbspt !== undefined) {
                    (window as any).hbspt.forms.create({
                        region: props.fields.region,
                        portalId: props.fields.portalId,
                        formId: props.fields.formId,
                        target: "#hubspot",
                    });
                }
            });
    
            window.addEventListener("message", event => {
                if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormReady") {
                    fetch("https://api.ipify.org?format=json")
                        .then(response => response.json())
                        .then(data => {
                           
                            if (window?.location?.pathname.includes("Cart") && cart?.cartLines?.length) {
                                const rfqProducts = cart?.cartLines?.filter(item => item.quoteRequired);
                                suppliers = rfqProducts
                                ?.map(item => item.brand?.name)
                                .filter((item, pos, self) => self.indexOf(item) === pos)
                                .join(", ");
                                model = rfqProducts?.map(item => item.erpNumber).join(", ");
                                vendorData = rfqProducts
                                    .map(item =>
                                        item.properties.vendor
                                            ? `${item.erpNumber}: ${item.properties.vendor}`
                                            : `${item.erpNumber}: SunSource`,
                                    )
                                    .join(", ");
                            } else if(page.type === "ProductDetailsPage" && product) {
                                const vendor = product?.properties?.vendor
                                ? `${product.productNumber}: ${product.properties.vendor}`
                                : `${product.productNumber}: ${siteMessage("SunSource")}`
                    
                                vendorData = vendor ? [vendor].join(", ") as any : "";
                            }

                            if(window?.location?.pathname.includes("Cart")){
                            } else {
                            vendorData = "";
                            suppliers = "";
                            model = ""; 
                            }
                                const ipAddressField = document.getElementsByClassName("hs_ip_address");
                                if (ipAddressField.length > 0) {
                                    ipAddressField[0].setAttribute("style", "display: block; position: absolute; left: -5000px; top: -5000px;");
                                }
                                const hiddenField = document.querySelector('input[name="ip_address"]');
                                hiddenField?.setAttribute("type", "");
    
                                if (hiddenField) {
                                    hiddenField?.setAttribute("value", data.ip);
                                }
                                
                                const vendorField = document.getElementsByClassName("hs_vendor");
                                if (vendorField.length > 0) {
                                    vendorField[0].setAttribute("style", "display: block; position: absolute; left: -5000px; top: -5000px;");
                                }
                                const vendorHiddenField = document.querySelector('input[name="vendor"]');
                                vendorHiddenField?.setAttribute("type", "");
    
                                if (vendorHiddenField) {
                                    vendorHiddenField?.setAttribute("value", vendorData);
                                }

                                const supplier_formsubmitHiddenField = document.querySelector('input[name="supplier_formsubmit"]');
                                if (supplier_formsubmitHiddenField) {
                                     supplier_formsubmitHiddenField?.setAttribute("type","text");
                                     supplier_formsubmitHiddenField?.setAttribute("placeholder",suppliers ? "Loading..." : "Suppliers");
                                }
                    
                                const model_seriesHiddenField = document.querySelector('input[name="model_series"]');
                                if (model_seriesHiddenField) {
                                    model_seriesHiddenField?.setAttribute("type", "text");
                                    model_seriesHiddenField?.setAttribute("placeholder",model ? "Loading...": "Model");
                                }

                                const recent_conversion_form_page_url = document.querySelector('input[name="recent_conversion_form_page_url"]');
                                if(recent_conversion_form_page_url){
                                    const pageUrl = window.location.href;
                                    recent_conversion_form_page_url?.setAttribute("value", pageUrl);
                                }

                                const recent_conversion_form_page_title = document.querySelector('input[name="recent_conversion_form_page_title"]');
                                if(recent_conversion_form_page_title){
                                    const pageTitle = document.title;
                                    recent_conversion_form_page_title?.setAttribute("value", pageTitle);
                                }

                                const form = document.getElementById('hubspot');
                                if (form) {
                                    // Select all the input, textarea, and select elements with specific names
                                    const inputs = form.querySelectorAll(
                                        'input[name="country_select___other"], input[name="zip"], input[name="firstname"], input[name="lastname"], input[name="email"], input[name="phone"], input[name="company"],  textarea[name="comment"], select'
                                    );

                                    inputs.forEach((input) => {
                                        if(window?.location?.pathname.includes("Cart") && (input.getAttribute("name") == "supplier_formsubmit" ||  input.getAttribute("name") == "model_series")){
                                            if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
                                              if(input.getAttribute("name") == "supplier_formsubmit"){
                                                input.value = suppliers;
                                              }
                                              if(input.getAttribute("name") == "model_series"){
                                                input.value = model;
                                              }

                                            }
                                        }
                                        else {
                                            if(!((suppliers || model) && (input.getAttribute("name") == "supplier_formsubmit" ||  input.getAttribute("name") == "model_series"))){
                                                // Check if the input is an HTMLInputElement or HTMLTextAreaElement
                                               if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
                                                   input.value = ''; // Clear the input values
                                                   input.style.backgroundColor = '#dfd9d9fc'; // Set the background color to the desired value dfd9d9fc
                                               }
                                               // Check if the element is a select (HTMLSelectElement)
                                               if (input instanceof HTMLSelectElement) {
                                                   input.selectedIndex = 0; // Set the first option as selected
                                               }
                                           } 
                                        }
                                        
                                    });
                                }

                                if(suppliers || model){
                                    setTimeout(()=>{
                                        const supplier_formsubmitHiddenField = document.querySelector('input[name="supplier_formsubmit"]');                 
                                        if (supplier_formsubmitHiddenField) {
                                            supplier_formsubmitHiddenField?.setAttribute("type","text");
                                            supplier_formsubmitHiddenField?.setAttribute("value",`${suppliers}`);
                                            supplier_formsubmitHiddenField?.setAttribute("placeholder","Suppliers");
                                         }
                            
                                        const model_seriesHiddenField = document.querySelector('input[name="model_series"]');
                                        if (model_seriesHiddenField) {
                                            model_seriesHiddenField?.setAttribute("type", "text");
                                            model_seriesHiddenField?.setAttribute("value",`${model}`);
                                            model_seriesHiddenField?.setAttribute("placeholder","Model");
                                        }
                                        
                                    },2000)
                                }
                               
                        })
                        .catch(error => {
                            console.error(`Error fetching IP address: ${error}`);
                        });
                }
            });
        }
    }

    useEffect(() => {
        loadHubSpotForm();

const css = `

 [data-test-selector="requestForQuoteModal"] > div {
    max-height: calc(100vh - 10px);
 }
 [data-test-selector="requestForQuoteModal"]  form fieldset > div {
    margin-bottom: 5px;
 }  
[data-test-selector="requestForQuoteModal"]  form fieldset ul {
   line-height: 15px;
 }  
[data-test-selector="requestForQuoteModal"]  form fieldset .hs-error-msg  {
  font-size: 12px !important;
 } 

[data-test-selector="requestForQuoteModal"]  form fieldset > div > div > div > input {
    border-radius: 2px;
    margin-top: 0px;
    height: 30px;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset > div > div > div > select {
    height: 30px;
    margin: 0px;
}

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="lastname"]) {
    min-width: 100%;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="email"]) {
    min-width: 100%;
}
    

/* If a fieldset contains a textarea with name="comment", set width to 100% */
[data-test-selector="requestForQuoteModal"]  form fieldset:has(textarea[name="comment"]) {
    width: 100%;
    min-width: 100%;
}

[data-test-selector="requestForQuoteModal"]  form fieldset textarea[name="comment"] {
    min-height: 50px;
}
    

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="company"]) {
    width: 50%;
    padding-right: 10px;
    float: left;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset:has(select[name="country_select"]) {
    width: 50%;
    padding-left: 10px;
    float: left;
}

    [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="supplier_formsubmit"]) {
        width: 50%;
    padding-left: 10px;
    float: right;
}
        [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="model_series"]) {
        width: 50%;
    padding-right: 10px;
    float: left;
}
    

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(select[name="industry_select"]) {
    width: 50%;
    padding-right: 10px;
    float: left;
}
 [data-test-selector="requestForQuoteModal"]  form .hs_recaptcha {
   width: 50%;
    display: inline-block;
    float: right;
    padding-top: 5px;
    right: -5px;
    position: relative;
}
    

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) {
    width: 100% ;
    padding-right: 10px;
    float: left;
    min-width: 100%;
    padding: 0px;
}

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) > div{
      display: flex;
    width: 100%;
    min-width: 100%;
    justify-content: space-between;
}

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) > div > div{
    flex-grow: 1;
}
    
    
 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] p, label{
   font-size: 13px;
} 
 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] p{
   margin-bottom: 8px;
} 

 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] h2{
    font-size: 18px;
    margin-bottom: 0px;
} 
   [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"]  {
   padding: 8px;
} 

 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] > div > div{
   padding: 8px 15px;
} 

`;

// Create a <style> element
const style = document.createElement("style");
style.type = "text/css";

// Inject the CSS rule into the <style> element
style.appendChild(document.createTextNode(css));

// Append the <style> element to the <head> of the document
document.head.appendChild(style);

 // Cleanup function to remove the style element when the component unmounts
 return () => {
    document.head.removeChild(style);
};
    }, []);

    // useEffect(() => {
    //     loadHubSpotForm();
    // }, [currentLocation.pathname]);

    return (
        <StyledWrapper {...styles.mainDiv}>
            <StyledWrapper {...styles.sectionOne}>
                <h2 style={{fontSize:"21px"}}>{translate("Submit request for pricing on RFQ products.")}</h2>
                <p>
                    {translate("Our sales team will be in touch to provide you a quote.")}
                </p>
            </StyledWrapper>
            <StyledWrapper {...styles.hubSpotWidgetMain} id="hubspot"></StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withIsInShell(withProduct(INTHubSpotWidget))),
    definition: {
        group: "Basic",
        icon: "Rtf",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.region,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.portalId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.formId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
